import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderValuePipe } from '@zero/shared/ui-pipes';
import { OrderData } from '@zero/shared/util-models';

@Component({
  selector: 'order-value',
  imports: [OrderValuePipe, CurrencyPipe],
  templateUrl: './order-value.component.html',
})
export class OrderValueComponent {
  @Input() public order: OrderData;
  @Input() public type: 'open' | 'filled' | 'canceled';
  @Input() public quoteToUse: number | undefined;
}
